<template>
  <!-- Change viewBox and fill params -->
  <svg
    xmlns="http://www.w3.org/2000/svg"
    :width="width"
    :height="height"
    viewBox="0 0 26 32"
  >
    <g>
      <path
        fill="#ff6264"
        d="M4.401 22.040c-2.23-2.263-3.607-5.372-3.607-8.802s1.377-6.539 3.608-8.804l-0.002 0.002c2.214-2.25 5.292-3.644 8.696-3.644 0.011 0 0.022 0 0.034 0h-0.002c0.005 0 0.010 0 0.016 0 3.409 0 6.492 1.394 8.711 3.643l0.001 0.001c2.23 2.263 3.607 5.372 3.607 8.802s-1.377 6.539-3.608 8.804l-8.689 8.838z"
      />
      <path
        fill="#464646"
        d="M13.129 1.588c0.005 0 0.010 0 0.015 0 3.191 0 6.078 1.304 8.157 3.408l0.001 0.001c2.090 2.099 3.382 4.995 3.382 8.192 0 0.016-0 0.032-0 0.048v-0.002c0 0.009 0 0.019 0 0.030 0 3.202-1.292 6.103-3.383 8.209l0.001-0.001-8.136 8.266-8.21-8.276c-2.090-2.099-3.382-4.995-3.382-8.192 0-0.016 0-0.032 0-0.048v0.002c-0-0.009-0-0.019-0-0.030 0-3.202 1.292-6.103 3.383-8.209l-0.001 0.001c2.081-2.1 4.966-3.4 8.155-3.4 0.006 0 0.013 0 0.019 0h-0.001zM13.129-0.001c-0.004 0-0.009 0-0.014 0-3.627 0-6.908 1.483-9.269 3.875l-0.001 0.001c-2.376 2.404-3.843 5.71-3.843 9.359s1.468 6.955 3.845 9.36l-0.001-0.001 9.322 9.406 9.248-9.396c2.376-2.404 3.843-5.71 3.843-9.359s-1.468-6.955-3.845-9.36l0.001 0.001c-2.362-2.399-5.645-3.886-9.275-3.886-0.004 0-0.007 0-0.011 0h0.001z"
      />
      <path
        fill="none"
        stroke="#464646"
        stroke-linejoin="round"
        stroke-linecap="round"
        stroke-miterlimit="4"
        stroke-width="1.641"
        d="M14.373 19.956c2.795-4.321 2.795-9.364 2.795-10.667h-9.708c0 1.305 0 6.349 2.796 10.667z"
      />
      <path
        fill="none"
        stroke="#464646"
        stroke-linejoin="round"
        stroke-linecap="round"
        stroke-miterlimit="4"
        stroke-width="1.641"
        d="M16.137 16.457c0.244 0.486 0.738 0.813 1.309 0.813 0.024 0 0.047-0.001 0.071-0.002l-0.003 0c1.993 0 3.245-2.822 3.245-4.444 0-2.178-2.363-2.090-3.5-1.341"
      />
    </g>
  </svg>
</template>

<script>
export default {
  props: {
    width: {
      type: String,
      default: ''
    },
    height: {
      type: String,
      default: ''
    },
    color: {
      type: String,
      default: ''
    }
  }
}
</script>
